var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoTennis24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_tennis24x24",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tennis",
    transform: "translate(2 2)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41649",
    "data-name": "Path 41649",
    d: "M332.9,391a1.9,1.9,0,1,0,1.9,1.9A1.9,1.9,0,0,0,332.9,391Z",
    transform: "translate(-320.729 -378.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41650",
    "data-name": "Path 41650",
    d: "M.417,319.706a1.422,1.422,0,0,0,0,2.012L.5,321.8a1.422,1.422,0,0,0,2.012,0L6.2,318.108l-2.093-2.093Z",
    transform: "translate(0 -306.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41651",
    "data-name": "Path 41651",
    d: "M159.891,1.092c-1.8-1.8-5.077-1.295-7.31.942-2.642,2.642-1.593,4.82-3.06,7.244l.684.685a6.688,6.688,0,0,0,.744-1.584,3.588,3.588,0,0,0,1.658,1.658,6.721,6.721,0,0,0-1.583.743l.684.684c2.4-1.463,4.6-.412,7.245-3.059,2.238-2.238,2.743-5.512.941-7.314Zm-1.313.2a2.6,2.6,0,0,1,1.078,1.048h-1.078Zm-5.852,2h.162V4.778h-1.037a6.061,6.061,0,0,1,.875-1.487Zm-1.182,3.865a4,4,0,0,1,.03-1.43h1.311V7.15C151.5,7.15,151.6,7.147,151.545,7.156Zm.324.943h1.015V9.113A2.6,2.6,0,0,1,151.871,8.1Zm3.387,1.311a4.006,4.006,0,0,1-1.424.031V8.1h1.424Zm0-2.26h-1.424V5.726h1.424Zm0-2.372h-1.424V3.291h1.424Zm0-2.436h-1.424V2.186a6.082,6.082,0,0,1,1.424-.845Zm2.372,5.965a6.037,6.037,0,0,1-1.424.822V8.1h1.424Zm0-1.157H156.2V5.726h1.424Zm0-2.372H156.2V3.291h1.424Zm0-2.436H156.2v-1.3a4.038,4.038,0,0,1,1.424-.053Zm1.167,4.812a1.594,1.594,0,0,0-.219,0V5.726h1.066a6.083,6.083,0,0,1-.845,1.428Zm1.147-2.376h-1.362V3.291h1.406a4.033,4.033,0,0,1-.044,1.487Z",
    transform: "translate(-144.987)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoTennis24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_tennis24x24.3a8ef86b8c8dfe4823de8cf37e4c8271.svg";